export const Colours = {
	primary: '#F47A30',
	secondary: '#1E73BE',
	white: '#FFF',
	black: '#000',
};
